module.exports = __webpack_public_path__ + "img/ic-ticket.ec5f05c3.svg";